import React from 'react'

import { JobStatusEnum } from '../../constants'
import useSessionStatusData from '../../hooks/useSessionStatusData'

const SessionStatsChips = () => {
  const { polledJobsByStatus, totalJobsCount } = useSessionStatusData()

  return <div className={'stats-container'}>
    <span className={'stats-cell'}>
      <span className={'big-number'}>{totalJobsCount}</span>
      <span className={'small-label'}>{window.I18n.t('clone_leagues_sessions.general.total')}</span>
    </span>
    <span className={'stats-cell'}>
      <span className={'big-number'}>{Object.keys(polledJobsByStatus?.[JobStatusEnum.COMPLETED]).length}</span>
      <span className={'completed-small-label'}>{window.I18n.t('clone_leagues_sessions.status.completed')}</span>
    </span>
    <span className={'stats-cell'}>
      <span className={'big-number'}>{Object.keys(polledJobsByStatus?.[JobStatusEnum.IN_PROGRESS]).length}</span>
      <span className={'in-progress-small-label'}>{window.I18n.t('clone_leagues_sessions.status.in_progress')}</span>
    </span>
    <span className={'stats-cell'}>
      <span className={'big-number'}>{Object.keys(polledJobsByStatus?.[JobStatusEnum.SCHEDULED]).length}</span>
      <span className={'scheduled-small-label'}>{window.I18n.t('clone_leagues_sessions.status.scheduled')}</span>
    </span>
  </div>
}

export default SessionStatsChips
